import { Add } from "@mui/icons-material";
import { Card, Grid } from "@mui/material";
import CustomDialog from "components/shared/Dialog/CustomDialog";
import { DeviceStatus, TOPICS } from "components/utils/enums";
import { handleDownloadCsv, handlePrintCsv } from "components/utils/handlers";
import { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { sendToSocket, setUpDeviceUsersSocket, unSubscribeSocketTopics } from "../../../redux/saga/socket";
import { deviceUsersActions } from "../../../redux/slice/deviceUsers.slice";
import { devicesActions } from "../../../redux/slice/devices.slice";
import { GET_DEVICE_USERS } from "../../../redux/types/shared.types";
import CustomTitle from "../../shared/CustomTitle";
import MyTable from "../../shared/Tables/MyTable/MyTable";
import MyTableToolbar from "../../shared/Tables/MyTable/MyTableToolbar";
import table from "../../shared/Tables/table.module.scss";
import AddDeviceForm from "./AddDeviceForm";
import DeviceUserPopup from "./DeviceUserPopup/DeviceUserPopup";
import { getDeviceUserColumns, UBUNTU_USERS_DOWNLOAD_COLS, WINDOWS_USERS_DOWNLOAD_COLS } from "./helper";
import { authActions } from "../../../redux/slice/auth.slice";
import { accessActions } from "../../../redux/slice/access.slice";
import { checkSinglePermission } from "components/shared/helper";
import { USER_PERMISSIONS } from "../Management/AccessManagement/helper";

const DeviceUsers = () => {
  const deviceUsers = useSelector(deviceUsersActions.selectors.getdeviceUsers);
  const currentDevice = useSelector(devicesActions.selectors.getSelectedDevice);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();
  const [addUserPopUs, setAddUserPopUp] = useState(false);
  const [setttingPopup, setSettingsPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState({})
  const currentUser = useSelector(authActions.selectors.getCurrentUser);
  const userPermissions = useSelector(accessActions.selectors.getUserPermissions)

  const handleAddUserClick = () => {
    if (currentDevice?.status === DeviceStatus.disconnected) {
      return toast.error("Device is Disconnected")
    }
    handleAddUserPopup();
  }
  const handleAddUserPopup = () => {
    setAddUserPopUp(!addUserPopUs)
  }

  const handleSettingsPopupOpen = (row) => {
    setSelectedUser(row);
    setSettingsPopup(true)
  }

  const handleSettingsPopupClose = (row) => {
    setSelectedUser({});
    setSettingsPopup(false)
  }

  useEffect(() => {
    if (id) {
      const payload = {
        deviceId: id,
      };
      dispatch({ type: GET_DEVICE_USERS, payload });
    }
  }, [dispatch, id]);

  const handleUserSearch = (term) => {
    setUserSearchTerm(term);
  };

  useEffect(() => {
    setUpDeviceUsersSocket(dispatch);
    return () => {
      unSubscribeSocketTopics([
        TOPICS.USERS
      ]);
    };
  }, [dispatch]);

  const filteredUsers = useMemo(() => {
    if (!userSearchTerm) return deviceUsers;
    const regex = new RegExp(userSearchTerm, "i");
    return deviceUsers.filter((alert) =>
      Object.values(alert).some((value) => regex.test(value))
    );
  }, [deviceUsers, userSearchTerm]);

  const addDeviceUser = (data) => {
    const payload = {
      os: currentDevice?.systemDetails?.os,
      uid: currentDevice?.uid,
      user: data
    }
    sendToSocket("CREATE_DEVICE_USER", payload);
    handleAddUserPopup()
  }
  const selectedDevice = useSelector(devicesActions.selectors.getSelectedDevice)
  const deviceUserColumns = useMemo(() => {
    return getDeviceUserColumns(selectedDevice?.systemDetails?.os, handleSettingsPopupOpen);
  }, [selectedDevice?.systemDetails?.os])

  const deviceUserDownloadColumns = useMemo(() => {
    return selectedDevice?.systemDetails?.os === "Ubuntu" ? UBUNTU_USERS_DOWNLOAD_COLS : WINDOWS_USERS_DOWNLOAD_COLS;
  }, [selectedDevice?.systemDetails?.os])

  return (
    <div>
      <CustomDialog borderRadius={'10px'} maxWidth={'lg'} title={'Add User Inside Device'} handleToggle={handleAddUserPopup} isOpen={addUserPopUs} >
        <AddDeviceForm addDeviceUser={addDeviceUser} />
      </CustomDialog>

      <CustomDialog borderRadius={'10px'} fullScreen={true} title={'Manage Device User Setting'} handleToggle={handleSettingsPopupClose} isOpen={setttingPopup} >
        <DeviceUserPopup selectedUser={selectedUser} />
      </CustomDialog>
      <Grid
        my={"15px"}
        container
        sx={{ justifyContent: { xl: "space-between", md: "center" } }}
        spacing={2}
      ></Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} xl={12} className={table.tableContainer}>
          <CustomTitle title={"Users"} count={deviceUsers?.length} />
          <Card>
            <MyTableToolbar
              placeHolder={"Search For Users"}
              onSearch={handleUserSearch}
              onDownload={() => handleDownloadCsv({ rows: filteredUsers, columns: deviceUserDownloadColumns, name: `${selectedDevice?.deviceName}_device_users` })}
              onPrint={() => handlePrintCsv({ rows: filteredUsers, columns: deviceUserDownloadColumns, name: `${selectedDevice?.deviceName}_device_users` })}
              isAlerts={false}
              btn2Txt={checkSinglePermission(USER_PERMISSIONS.ADD_DEVICE_USER, userPermissions, currentUser?.role) ? "Add User" : null}

              btn2Icon={Add}
              handleBtn2Click={handleAddUserClick}

            />
            <MyTable
              checkboxSelection={false}
              columns={deviceUserColumns}
              rows={filteredUsers}
            />
          </Card>
        </Grid>
      </Grid>
      <br />

    </div>
  );
};

export default DeviceUsers;
